import useTeams from "@/hooks/useTeams";
import React, { useMemo } from "react";
import MultiSelect from "react-select";

interface Props {
  value: number[];
  onChange(value: number[]): void;
}

export default function TeamMultiSelect({ value, onChange }: Props) {
  const { teamOptions } = useTeams();

  const selectedTeams = useMemo(() => {
    return teamOptions.filter((option) => value.includes(Number(option.value)));
  }, [teamOptions, value]);

  return (
    <MultiSelect
      isMulti
      name="teams"
      options={teamOptions}
      value={selectedTeams}
      className="basic-multi-select w-full"
      classNamePrefix="select"
      onChange={(e) => onChange(e.map((item) => Number(item.value)))}
    />
  );
}
